import OnboardingContainer from 'client/GrowthEngineering/OnboardingContainer.vue';

export default [
  {
    path: '/onboarding',
    name: 'onboarding',
    meta: {
      loadLegacyStyles: false,
      title: 'Onboarding',
      layout: 'fullpage',
    },
    components: {
      fullLayout: OnboardingContainer,
    },
  },
];
